<div class="widget-actions">
  @if (_store.hasClipboardPluginSg()) {
    <clipboard-action />
  }
  @if (_store.creationSg()) {
    <i
      class="atn-icon atn-plus atn-blue"
      (click)="addClickHandler()"
    ></i>
  }

  <!--  FIXME: see how can we include this icons here -->
  <!-- User custom actions -->
  <ng-content></ng-content>

  @if (_store.hasExcelPluginSg()) {
    <excel-action />
  }
  @if (_store.showColumnSettingsSg()) {
    <settings-action />
  }
</div>
